module.exports = __webpack_public_path__ + "static/media/replacement_aligners.34c74cc5.png";